<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  font-family: $font-family;
  color: $text-primary;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
